import Vue from "vue";
import Membership from "./apps/Membership.vue"

Vue.config.productionTip = false;

import VueInputAutowidth from 'vue-input-autowidth';
Vue.use(VueInputAutowidth);

import { VueMaskDirective } from 'v-mask';
Vue.directive('mask', VueMaskDirective);

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { 
  siteKey: '6Lf10_whAAAAAHUFvDduK4d-dUtFXTY5kMJ-QFYw',
  loadRecaptchaScript: false,
})

import FloatingVue from 'floating-vue';

Vue.use(FloatingVue, {
  themes: {
    tooltip: {
      html: true,
    },
  },
})

var axios = require('axios');
window.api = axios.create({
  baseURL: '/api/new-dashboard/',
});

window.apiJoin = axios.create({
  baseURL: '/api/new-join-form',
});

window.apiTrack = axios.create({
  baseURL: '/api/new-join-form/track',
});

Vue.filter("addressDisplay", function (address) {
  var string = address.address_1 || '';

  if (address.address_2) {
    string += `, ${address.address_2}`;
  }
  
  if (address.state) {
    string += ` ${address.state}`;
  }

  if (address.postcode) {
    string += `, ${address.postcode}`;
  }
  return string;
});

new Vue({
  render: h => h(Membership)
}).$mount(`#app`);

